import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useMediaViewerListener } from './useMediaViewerListener';
import { fg } from '@atlaskit/platform-feature-flags';

// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
var handleScrollDeboubced = function handleScrollDeboubced(scrollHandler, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(function () {
      scrollHandler.apply(void 0, args);
    }, delay);
  };
};
export var useGetCurrentScrollPosition = function useGetCurrentScrollPosition(isHeightSetFromContent) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var defaultScrollPosition = useRef(0); // mutable ref to 0 - return this value when the media is open
  var prevScrollPosition = useRef(0);
  var _useMediaViewerListen = useMediaViewerListener(),
    isMediaOpen = _useMediaViewerListen.isMediaOpen;
  useEffect(function () {
    if (fg('platform_embedded-confluence-save-scroll-position')) {
      var handleScroll = handleScrollDeboubced(function () {
        if (!isMediaOpen) {
          /*
          	Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
          	it may already have been opened or closed, and we do not have control over the actions that occur
          	just before the media viewer is activated (which happens in a different package that we do not manage).
          	Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
          	This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
          	which is misleading since the container height will have been reduced at this point.
          	To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
          	When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
          	inaccuracies associated with saving the scroll position under the conditions of a condensed height.
          */
          prevScrollPosition.current = scrollPosition;
          setScrollPosition(window.scrollY);
        }
      }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [isMediaOpen, scrollPosition]);
  useEffect(function () {
    if (isHeightSetFromContent && fg('platform_embedded-confluence-save-scroll-position')) {
      // Restore the scroll position back to the value saved before any media file was open
      window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }
  }, [isHeightSetFromContent, isMediaOpen]);
};